/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetOrgInvitesOptions, GetOrgInvitesResponses } from '../../models/GetOrgInvites'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get all users invited to the org.
 * @summary Get Org Invites
 * {@link /org/invites}
 */
export function getOrgInvites<ThrowOnError extends boolean = true>(options: Options<GetOrgInvitesOptions, ThrowOnError> = {}): Promise<UnwrappedResult<GetOrgInvitesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/org/invites', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetOrgInvitesResponses, ThrowOnError>>
}
